<template>
  <div class="overlay">
    <div class="overlay_inner channel_list">
        <search-input
            input-class="search clearable"
            v-model="search"
            :showLabel="false"
            :pClass="'field search-field'"
            :inputPlaceholder="this.$gettext('Vyhledat příjemce')"
        >
        </search-input>
      <p class="note" v-translate>Seznam přijemců</p>
      <div class="recipients_list">
        <ul>
          <li v-for="recipient in recipientsToShow">
            {{ recipient }}
          </li>
        </ul>
      </div>
      <pagination
          :offset="formFields.offset"
          :limit="formFields.limit"
          :total-count="filteredLength"
          @offset="setOffset"
          @limit="setLimit"
      ></pagination>
      <a class="btn btn_action btn_close" :title="'Zavřít' | translate" @click.stop.prevent="emitClose"
         v-translate>Zavřít</a>
    </div>
  </div>
</template>

<script>

import Pagination from "../../../common/Pagination"
import formFields from "../../../../components/mixins/form-fields"

export default {
  name: "NewMessageRecipientsPopup",
  components: {Pagination},
  mixins: [formFields],
  props: {
    recipientsRequest: Object,
    combineRecipientConditionsRequest: Boolean
  },
  data: function () {
    return {
      recipients: [],
      totalCount: 0,
      entityService: null,
      search: null,
      filteredLength: 0,
    }
  },
  created: function (MessageService) {
    this.entityService = MessageService
    this.loadRecipients()
  },
  computed: {
    recipientsToShow() {
      let filtered = this.search ? this.recipients.filter(substr => substr.includes(this.search)):this.recipients;
      this.filteredLength = filtered.length;
      return filtered.slice(this.formFields.offset, this.formFields.offset+this.formFields.limit);
    }
  },
  methods: {
    emitClose() {
      this.$emit('close-popup')
    },
    setOffset(value) {
      this.formFields.offset = value;
    },
    setLimit(value){
      this.formFields.limit = value;
      this.formFields.offset = 0;
    },
    loadRecipients() {
      let params =  {
        recipients: this.recipientsRequest,
        id_selected_operator: this.$_loggedUser_selectedOperatorId,
        combine_recipients_conditions: this.combineRecipientConditionsRequest,
      }

      this.entityService.getNewMessageRecipients(params)
          .then((data) => {
            this.recipients = data['recipients'].sort();
            this.totalCount = data['totalCount']
          })
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/messages/popup/NewMessageRecipientsPopup.vue